import {EntityType} from "../@core/entityType";
import {Operation} from "reactcoregk";

export const entityType = EntityType.Version;
export const entityOperations = [
  Operation.getAll,
  Operation.create,
  Operation.update,
  Operation.delete,
];
